export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13501.201c51fa.jpg";